var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileViewQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#FF6812"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 11.5341H8.45979L11.6631 8.33018C11.7501 8.24251 11.7988 8.12392 11.7986 8.00037C11.7984 7.87683 11.7492 7.75842 11.6619 7.67106C11.5745 7.5837 11.4561 7.53453 11.3326 7.5343C11.2091 7.53408 11.0905 7.58283 11.0029 7.66987L7.00269 11.6708C6.91558 11.7586 6.8667 11.8773 6.8667 12.001C6.8667 12.1247 6.91558 12.2433 7.00269 12.3311L11.0029 16.3321C11.0905 16.4191 11.2091 16.4679 11.3326 16.4676C11.4561 16.4674 11.5745 16.4182 11.6619 16.3309C11.7492 16.2435 11.7984 16.1251 11.7986 16.0016C11.7988 15.878 11.7501 15.7594 11.6631 15.6718L8.45979 12.4679H16.6665C16.7904 12.4679 16.9091 12.4187 16.9966 12.3311C17.0842 12.2436 17.1334 12.1248 17.1334 12.001C17.1334 11.8771 17.0842 11.7584 16.9966 11.6708C16.9091 11.5833 16.7904 11.5341 16.6665 11.5341Z",
    fill: "#FF6812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileViewQuestion);
export default __webpack_public_path__ + "static/media/mobile-view-question.dd5d97fd71eb2b82dcd2ad6c26e5f36d.svg";
export { ForwardRef as ReactComponent };